
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  layout: 'reference',
  source: 'endpoint',
  description: 'API reference for managing consent',
  childTocLevel: 4
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const Schema = makeShortcode("Schema");
const MDXCodeBlock = makeShortcode("MDXCodeBlock");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Consent' subtitle='API reference for managing consent' compact mdxType="Header" />
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Endpoints`}</th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/consent/events/get`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Retrieve consent events`}</td>
        </tr>
      </tbody>
    </table>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`See also`}</th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/item/get`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Retrieve an Item (includes Item consent details)`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "consenteventsget"
    }}>{`/consent/events/get`}</h4>
    <Schema method='POST' route='/consent/events/get' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/consent/events/get' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/consent/events/get \\
  -H 'Content-Type: application/json' \\
  -d '{
    "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
    "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
    "access_token": String
  }'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: ConsentEventsGetRequest = {
  access_token: accessToken,
};
try {
  const response = await plaidClient.consentEventsGet(request);
  const consentEvents = response.data.consent_events;
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = ConsentEventsGetRequest(access_token=accessToken)
response = client.consent_events_get(request)
consent_events = response['consent_events']
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`ConsentEventsGetRequest request = new ConsentEventsGetRequest()
  .accessToken(accessToken);
Response<ConsentEventsGetResponse> response = client().consentEventsGet(request).execute();
List<ConsentEvent> consentEvents = response.body().getConsentEvents();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::ConsentEventsGetRequest.new({ access_token: access_token })
response = client.consent_events_get(request)
consent_events = response.consent_events
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewConsentEventsGetRequest(accessToken)
resp, _, err := client.PlaidApi.ConsentEventsGet(ctx).ConsentEventsGetRequest(*request).Execute()
if err != nil {
  // handle error
}

consentEvents := resp.GetConsentEvents()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.ConsentEventsGetRequest{AccessToken: accessToken}
resp, err := client.Consent.GetEvents(ctx, request)
if err != nil {
    // handle error
}

consentEvents := resp.GetConsentEvents()
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/consent/events/get' type='response' mdxType="Schema" />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "consenteventsget",
        level: 4,
        title: "/consent/events/get",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
